module.exports = __webpack_public_path__ + "static/media/Grupo 4919@2x.929a65ee.png";